export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[680px] sm:min-h-[750px] md:min-h-[820px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Dramatic%20industrial%20workshop%20scene%20showing%20a%20focused%20technician%20hands%20crimping%20colorful%20network%20cables%20on%20a%20workbench%20with%20laptops%2C%20cable%20testers%2C%20fiber%20optic%20strands%2C%20network%20switches%20and%20precision%20tools%20laid%20out%2C%20warm%20amber%20workshop%20lighting%20cutting%20through%20soft%20shadows%2C%20cinematic%20close-up%20photography%20with%20shallow%20depth%20of%20field%2C%20dark%20charcoal%20workshop%20background%2C%20vibrant%20orange%20accent%20highlights%20on%20tool%20handles%2C%20editorial%20trade-school%20aesthetic%2C%20highly%20detailed%20realistic%20texture&width=1920&height=1080&seq=techybootcamp-hero-01&orientation=landscape')",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80"></div>
      <div className="absolute inset-0 bg-grid-lines opacity-40 mix-blend-overlay"></div>

      <div className="relative z-10 w-full px-4 md:px-8 pt-32 pb-20">
        <div className="max-w-5xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/40 text-primary-300 text-xs font-mono uppercase tracking-[0.15em] sm:tracking-[0.2em] mb-6 flex-wrap">
            <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse shrink-0"></span>
            <span className="whitespace-nowrap">Now Enrolling — Next Cohort Starts Soon</span>
          </div>

          <h1 className="text-background-50 font-heading font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl leading-[1.05] sm:leading-[1.02] tracking-tight">
            Real tools. <span className="text-primary-500">Real skills.</span>
            <br className="hidden sm:block" />
            Real careers in tech.
          </h1>

          <p className="mt-6 text-lg md:text-xl text-background-200 max-w-2xl leading-relaxed">
            TechyBootcamp trains you hands-on in the tech skills companies are actually hiring for
            right now — wire terminations, networks, security, fire &amp; alarm systems, and
            everything in between. Tools and laptop included. No fluff.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <a
              href="tel:8888663428"
              className="inline-flex items-center justify-center gap-3 px-5 sm:px-7 py-4 rounded-md bg-background-50/10 hover:bg-background-50/20 border border-background-50/30 text-background-50 font-semibold text-sm sm:text-base whitespace-nowrap cursor-pointer transition-colors backdrop-blur-sm"
            >
              <i className="ri-phone-fill text-primary-400" aria-hidden="true"></i>
              Call 888-866-3428
            </a>
            <a
              href="#apply"
              className="inline-flex items-center justify-center gap-2 px-5 sm:px-7 py-4 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm sm:text-base whitespace-nowrap cursor-pointer transition-colors"
            >
              Start Your Application
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
          </div>

          <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl">
            {[
              { icon: "ri-tools-fill", label: "Tools Included", value: "$1,200+" },
              { icon: "ri-macbook-line", label: "Laptop Provided", value: "Yours to Keep" },
              { icon: "ri-time-line", label: "Program Length", value: "12–16 Weeks" },
              { icon: "ri-briefcase-4-line", label: "Job Placement", value: "94%" },
            ].map((s) => (
              <div key={s.label} className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500/20 text-primary-400 shrink-0">
                  <i className={`${s.icon} text-lg`} aria-hidden="true"></i>
                </div>
                <div className="min-w-0">
                  <div className="text-background-50 font-heading font-bold text-base sm:text-lg leading-tight">
                    {s.value}
                  </div>
                  <div className="text-background-300 text-xs uppercase tracking-widest font-mono mt-0.5">
                    {s.label}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 hidden md:flex flex-col items-center gap-2 text-background-200">
        <span className="text-[10px] uppercase tracking-[0.3em] font-mono">Scroll</span>
        <div className="w-px h-10 bg-background-200/50"></div>
      </div>
    </section>
  );
}